import { render, staticRenderFns } from "./assetsRecipient.vue?vue&type=template&id=548639f5&"
import script from "./assetsRecipient.vue?vue&type=script&lang=js&"
export * from "./assetsRecipient.vue?vue&type=script&lang=js&"
import style0 from "./assetsRecipient.vue?vue&type=style&index=0&id=548639f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports